import React from "react";
import { Star } from "lucide-react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

export const KantoorCard = ({ kantoor, compact = false }) => {
  const { t } = useTranslation();
  return (
    <div className="beecenter-card p-6 flex flex-col h-full" data-testid={`kantoor-card-${kantoor.id}`}>
      <div className="flex items-start gap-4">
        <div className="w-14 h-14 rounded-xl overflow-hidden bg-slate-100 flex-shrink-0 ring-1 ring-slate-200">
          {kantoor.logo_url ? (
            <img src={kantoor.logo_url} alt={kantoor.naam} className="w-full h-full object-cover" />
          ) : (
            <div className="w-full h-full flex items-center justify-center text-[#1A2B4A] font-bold text-xl">
              {kantoor.naam?.[0]}
            </div>
          )}
        </div>
        <div className="flex-1 min-w-0">
          <h3 className="font-heading font-bold text-lg text-[#1A2B4A] truncate">{kantoor.naam}</h3>
          <div className="flex items-center gap-1 mt-1">
            <Star size={14} className="fill-[#F5A623] text-[#F5A623]" />
            <span className="text-sm font-semibold text-[#1A2B4A]">{kantoor.rating?.toFixed(1)}</span>
            <span className="text-xs text-slate-500">({kantoor.reviews_count} {t("kantoor_card.reviews")})</span>
          </div>
          <p className="text-xs text-slate-500 mt-0.5">{kantoor.locatie}</p>
        </div>
      </div>
      {!compact && (
        <p className="text-sm text-slate-600 mt-4 line-clamp-3">{kantoor.beschrijving}</p>
      )}
      <div className="flex flex-wrap gap-1.5 mt-4">
        {(kantoor.specialismes || []).slice(0, 3).map((s) => (
          <span key={s} className="pill-amber" data-testid={`spec-${s}`}>{s}</span>
        ))}
      </div>
      {!compact && (
        <div className="mt-5 pt-5 border-t border-slate-100">
          <Link to={`/kantoren/${kantoor.id}`} className="btn-navy w-full !py-2.5 text-sm" data-testid={`bekijk-profiel-${kantoor.id}`}>
            {t("kantoor_card.view_profile")}
          </Link>
        </div>
      )}
    </div>
  );
};
